<template>
  <div class="container product-container">
    <van-notice-bar
      v-show="notice != ''"
      left-icon="volume-o"
      :text="notice"
      mode="closeable"
    />
    <div class="tui-banner-swiper">
      <van-swipe :autoplay="5000" :duration="150" @change="bannerChange">
        <div v-for="(item, index) in banner" :key="index">
          <van-swipe-item :data-index="index">
            <img :src="item.pictureUrl" class="tui-slide-img" />
          </van-swipe-item>
        </div>
      </van-swipe>
      <!-- <div class="tui-banner-tag">
            <div>{{ bannerIndex + 1 }}/{{ banner.length }}</div>
        </div> -->
    </div>
    <div class="tui-pro-detail">
      <div class="tui-product-title tui-radius-all">
        <div class="tui-pro-titbox">
          <div class="tui-pro-title">{{ productDetails.chineseName }}</div>
          <div class="tui-pro-text">{{ productDetails.subtitle }}</div>
        </div>
        <div class="tui-pro-pricebox">
          <p class="p-point">{{ productDetails.integralNum }}积分</p>
          <p class="p-price">市场价￥{{ productDetails.salePriceWithTax }}</p>
          <div class="distribution-result">
            已兑出 <span style="color: red">{{ productDetails.saleNum }}</span>
          </div>
          <!-- <div class="tui-share-box" @click="collecting">分享</div> -->
        </div>
        <!-- v-if="available == true" -->
        <div class="tui-box tui-attr-title">
          <div
            class="tui-list-cell"
            style="flex: 6"
            @click="popupAddress = true"
          >
            <van-field
              readonly
              v-model="city"
              clickable
              label="配送至"
              :value="city"
              @click="popupAddress = true"
            />
            <!-- <div class="tui-ml-auto">
              <van-icon name="arrow" color="#dadada" />
            </div> -->
          </div>
          <!--根据区域查库存量 <span class="distribution-result" v-if="Product == true"
            >库存 <span style="color: red">{{ hasProduct }}</span></span
          > -->
          <span class="distribution-result"
            >库存
            <span style="color: red">{{
              productDetails.available > 0 ? productDetails.available : 0
            }}</span></span
          >
          <!-- <div class="tui-last"></div> -->
          <!-- <div class="flex padding-sm" @click="guarantee = true">
                    <div class="tui-bold tui-cell-title">服务</div>
                    <div class="tui-guarantee">
                        <div class="tui-guarantee-item">
                            <van-icon name="success" color="#1e53a4" />
                            <p class="tui-pl">可配送海外</p>
                        </div>
                        <div class="tui-guarantee-item">
                            <van-icon name="success" color="#1e53a4" />
                            <p class="tui-pl">店铺发货&售后</p>
                        </div>
                        <div class="tui-guarantee-item">
                            <van-icon name="success" color="#1e53a4" />
                            <p class="tui-pl">7天无理由退货</p>
                        </div>
                        <div class="tui-guarantee-item">
                            <van-icon name="success" color="#1e53a4" />
                            <p class="tui-pl">闪电退款</p>
                        </div>
                        <div class="tui-guarantee-item">
                            <van-icon name="success" color="#1e53a4" />
                            <p class="tui-pl">极速审核</p>
                        </div>
                    </div>
                </div> -->
        </div>
         <div class="tui-box tui-attr-title" v-if="productDetails.isBooking == 1" style="pointer-events:none">
          <div class="tui-paddingright tui-bold">预售商品，下单后{{productDetails.bookingDeliverDay}}日发货</div>
        </div>
        <div class="tui-box tui-attr-title xf" @click="popupArea = true">
          <div class="tui-paddingright tui-bold">限发区域</div>
          <van-icon name="arrow" color="#999" />
        </div>
        <div
          class="tui-box tui-attr-title yx"
          @click="exchange"
          v-if="cardShow == 0"
        >
          <div class="tui-paddingright tui-bold">已选</div>
          <div class="yxcount">X{{ value }}</div>
        </div>
        <div class="tui-radius-all tui-attr-title" @click="allComments()">
          <div class="tui-list-cell tui-between">
            <div class="tui-bold tui-cell-title">商品评价</div>
            <div class="yxcount">共{{ productDetails.commentCount }}条评价</div>
            <!-- <div class="tui-flex-center" @click="common">
                    <p class="tui-cmt-all">100%</p>
                    <p>好评</p>
                    <van-icon name="arrow" color="#dadada" />
                </div> -->
          </div>
        </div>
        <div class="tui-box">
          <ul class="ts">
            <li>正品货源</li>
            <li>不支持无理由退换</li>
            <li>不支持发票</li>
          </ul>
        </div>

        <!-- <div class="tui-list-cell tui-attr-title">
          <div class="tui-bold">商品介绍</div>
        </div> -->
        <div class="text">
          <van-tabs v-model="active">
            <van-tab title="产品详情"
              ><div v-html="productDescribleContent"></div
            ></van-tab>
            <van-tab title="售后方式"
              ><p v-html="productDetails.afterSaleContent"></p
            ></van-tab>
          </van-tabs>
        </div>

        <!-- <div class="text">
          <div class="text-title">产品详情</div>
          <div v-html="productDescribleContent"></div>
        </div> -->
        <!-- <div class="tui-box tui-attr-title" v-if="available == false">
          <div class="tui-paddingright tui-bold">总库存量:</div>
          <div>
            {{ productDetails.available > 0 ? productDetails.available : 0 }} 件
          </div>
        </div> -->
        <!-- <div class="tui-box tui-attr-title">
          <div class="tui-paddingright tui-bold">好评率:</div>
          <div>100%</div>
        </div> -->
      </div>

      <!-- <div class="tui-radius-all">
                <div class="tui-list-cell" @click="coupon">
                    <div class="tui-bold tui-cell-title">优惠</div>
                    <div class="tui-flex-center">使用优惠预估价</div>
                    <div class="tui-ml-auto">
                        <van-icon name="arrow" color="#dadada" />
                    </div>
                </div>

                <div class="tui-list-cell" @click="showPopup" style="padding-top: 0">
                    <div class="tui-bold tui-cell-title"></div>
                    <div>
                        <div class="tui-promotion-box">
                            <span class="tui-tag text-sm">满减</span>
                            <p>满1件，立减最低1件商品价格</p>
                        </div>
                        <div class="tui-promotion-box">
                            <span class="tui-tag text-sm">满减</span>
                            <p>满2件，立减最低2件商品价格</p>
                        </div>
                        <div class="tui-promotion-box">
                            <span class="tui-tag text-sm">满减</span>
                            <p>满3件，立减最低3件商品价格</p>
                        </div>
                    </div>
                </div>
            </div> -->

      <!-- <div class="tui-radius-all">

    <div class="tui-list-cell" @click="popupMent=true" style="margin-left: 0;margin-right: 0">

    <div class="tui-bold">品质分期</div>

    <div class="tui-flex-center text-theme margin-left">

    享6期分期免息

    </div>

    <div class="tui-ml-auto">

    <span class="text-999">测算</span>

    <van-icon name="arrow" color="#dadada" />

    </div>

    </div>

    <div class="padding-bottom-xl padding-left-sm">

    <span class="tui-tag text-sm margin-right padding-lr">积分239.9*12期</span>

    <span class="tui-tag text-sm margin-right">积分239.9*12期</span>

    <span class="tui-tag text-sm margin-right">积分239.9*12期</span>

    </div>

    </div> -->

      <!-- <div class="tui-list-cell tui-radius-all">
            <div class="tui-bold tui-cell-title">已选</div>
            <div class="tui-selected-box">{{ productDetails.code }}</div>
            <div class="tui-ml-auto">
                <van-icon name="arrow" color="#dadada" />
            </div>
        </div> -->

      <!--		<div class="tui-product-status">-->
      <!--		<div v-for="(item, index) in productStatus" :key="index" :class="[productStatusIndex==index?'tui-product-status-active':'']" @click="productStatusIndex=index">{{item}}</div>-->
      <!--		</div>-->
    </div>
    <!-- <div>
      <div class="tui-list-cell padding-left">
        <div class="tui-bold">商品介绍</div>
      </div>
      <div class="text">
        <div v-html="productDescribleContent"></div>
      </div>
      <div class="tui-product-img">
        <img v-for="(item, index) in imgList" :key="index" :src="item" />
      </div>
      <div>
        <div class="recommend-title">
          <p class="line"></p>
          <p class="title">更多推荐</p>
          <p class="line"></p>
        </div>
      
        <van-swipe class="my-swipe" :autoplay="3000">
          <van-swipe-item>
            <productItem
              :productList="productList"
              @click="detail"
            ></productItem>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div> -->

    <!--底部操作栏-->
    <div class="tui-operation">
      <div class="flex dhbox">
        <div class="tui-flex" v-if="cardShow == 0">
          <van-button
            plain
            round
            block
            color="#979797"
            type="primary"
            @click="goshoping()"
            >加入购物车</van-button
          >
        </div>
        <div class="tui-flex tui-paddingleft">
          <van-button
            round
            block
            color="var(--theme-color-main)"
            type="primary"
            @click="exchange"
            >立即兑换
          </van-button>
        </div>
      </div>
      <div class="tui-operation-left">
        <div class="tui-operation-items" @click="goService" v-if="serviceBtn">
          <van-icon name="service-o" size="18px" />
          <div class="tui-operation-text">客服</div>
        </div>
        <div class="tui-operation-items" v-if="cardShow == 0">
          <van-icon
            name="like-o"
            v-if="isCollected == false"
            @click="collectSave()"
            size="18px"
          ></van-icon>
          <van-icon
            name="like"
            color="var(--theme-color-main)"
            @click="collectSave()"
            size="18px"
            v-if="isCollected == true"
          ></van-icon>
          <div class="tui-operation-text">收藏</div>
        </div>
        <div class="tui-operation-items" v-if="cardShow == 0" @click="gocard">
          <van-icon name="shopping-cart-o" size="18px" />
          <div class="tui-operation-text">购物车</div>
        </div>
      </div>
    </div>
    <!--底部操作栏--->

    <!--底部选择层-->
    <van-popup v-model="popupShow" position="bottom" round>
      <div class="tui-popup-box">
        <div class="tui-product-box">
          <img :src="banners" class="tui-popup-img" />
          <div class="tui-popup-price">
            <div class="tui-name">{{ chineseName }}</div>
            <div class="tui-amount tui-bold">{{ integralNum }}积分</div>
          </div>
        </div>
        <div class="tui-popup-scroll">
          <div class="tui-scrollview-box">
            <div
              class="chose-ck"
              v-for="(item, index2) in codeList"
              :key="index2"
            >
              <!-- <div class="tui-bold tui-attr-title">{{item.name}}</div> -->
              <p>{{ item.name }}</p>
              <!-- <div class="tui-attr-box"> -->
              <!-- <div class="tui-attr-item" :class="specsIndex == item.code+inde ? 'tui-attr-active' : ''" v-for="(it, index) in item.productPropertyValues" :key="item.code+index" @click="choseSpecs(item.code+inde)">
                                {{ it.valueName }}
                            </div> -->
              <dt
                :class="{ check: index === iac[index2] }"
                v-for="(it, index) in item.productPropertyValues"
                :key="item.code + index"
                @click="choseSpecs(index2, index, $event,it)"
              >
                <span :class="{ grey: it.available <1 }">{{ it.valueName }}</span>
              </dt>
              <!-- </div> -->
            </div>
            <diV v-if="codeList.length == 0">
              <div class="tui-bold tui-attr-title">规格</div>
              <div class="tui-attr-box">
                <div class="tui-attr-item">默认规格</div>
              </div>
            </diV>
            <div
              class="tui-number-box tui-attr-title"
              v-if="available == false"
            >
              <div class="tui-paddingright tui-bold">库存量:</div>
              <div>{{ kucun > 0 ? kucun : 0 }}件</div>
            </div>
            <div
              class="tui-number-box tui-bold tui-attr-title"
              v-if="cardShow == 0"
            >
              <div class="tui-attr-title">数量</div>
              <van-stepper v-model="value" :max="num" @change="addplus()" />
            </div>

            <!-- <div class="tui-bold tui-attr-title">保障服务</div>

    <div class="tui-attr-box">

    <div class="tui-attr-item">半年掉钻保 积分4.0</div>

    </div>

    <div class="tui-bold tui-attr-title">只换不修</div>

    <div class="tui-attr-box">

    <div class="tui-attr-item">三月意外换积分2.0</div>

    <div class="tui-attr-item">半年意外换积分2.0</div>

    </div> -->
          </div>
        </div>
        <div
          class="tui-operation tui-right-flex tui-popup-btn"
          v-if="type == 2&&kucunvalue"
        >
          <div class="tui-flex-1">
            <van-button
              plain
              round
              block
              color="#979797"
              type="primary"
              @click="showPopup"
              >确认</van-button
            >
          </div>
        </div>
        <div
          class="tui-operation tui-right-flex tui-popup-btn"
          v-if="type == 1&&kucunvalue"
        >
          <div class="tui-flex-1">
            <van-button
              round
              block
              color="var(--theme-color-main)"
              type="primary"
              @click="submit"
              >立即兑换</van-button
            >
          </div>
        </div>
        <div
          class="tui-operation tui-right-flex tui-popup-btn"
          v-if="!kucunvalue"
        >
          <div class="tui-flex-1">
            <van-button
             plain
              round
              block
              color="#979797"
              type="primary"
              >库存不足</van-button
            >
          </div>
        </div>
        <div class="tui-right">
          <van-icon
            name="close"
            @click="popupShow = false"
            size="22px"
            color="#848897"
          />
        </div>
      </div>
    </van-popup>
    <!--底部选择层-->
    <!--服务底部弹出层-->
    <van-popup
      v-model="guarantee"
      closeable
      close-icon="close"
      position="bottom"
      round
      :style="{ height: '50%' }"
    >
      <div>
        <div class="text-center padding text-lg text-bold">服务</div>
        <div class="padding-lr text-xsm">
          <div class="flex align-center margin-bottom-7">
            <van-icon name="passed" color="#d80c18" />
            <p class="margin-left-xs text-bold">运费7天退货</p>
          </div>
          <div class="text-999 text-sm">支持7天无理由退货（拆封后不支持）</div>
        </div>
        <div class="fixed bg-white">
          <div class="padding-lr padding-bottom-xl">
            <van-button
              round
              color="var(--theme-color-main)"
              size="small"
              block
              @click="guarantee = false"
            >
              确定
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!--服务底部弹出层-->
    <!--地址底部弹出层-->
    <van-popup
      v-model="popupAddress"
      confirm-button
      position="bottom"
      round
      :style="{ height: '55%' }"
    >
      <div>
        <!-- <div class="text-center padding-top text-lg text-bold">送至</div> -->
        <div class="padding-lr">
          <van-area
            title="选择地址"
            ref="cascaderMallCatergory"
            :area-list="options"
            @confirm="haierOrderCheckArea"
            @cancel="popupAddress = false"
            :columns-placeholder="['请选择', '请选择', '请选择']"
          />
        </div>
        <!-- <div class="">
                    <div class="padding-lr padding-bottom-xl">
                        <van-button round color="#d80c18" size="small" block>确认</van-button>
                    </div>
                </div> -->
      </div>
    </van-popup>
    <!--地址底部弹出层-->
    <!--分期底部弹出层-->
    <van-popup
      v-model="popupMent"
      closeable
      close-icon="close"
      position="bottom"
      round
      :style="{ height: '50%' }"
    >
      <div class="text-center padding-top text-lg text-bold">送至</div>
      <div class="margin-sm">
        <ul class="ment">
          <li>
            <span class="ment-money">222.50</span>
            <span class="text-999">× 3期</span>
          </li>
        </ul>
      </div>
    </van-popup>
    <!-- 配送限制 -->
    <van-popup
      v-model="popupArea"
      position="bottom"
      round
      :style="{ height: '50%' }"
    >
      <div class="areatip">
        须知：当前商品在下列省份及区域存在无法兑换派送情况，请谅解！
      </div>
      <ul
        class="areabox"
        v-if="productDetails&&productDetails.mProductSalesAreaResponseList&&productDetails.mProductSalesAreaResponseList.length != 0"
      >
        <li
          v-for="(item, index) in productDetails.mProductSalesAreaResponseList"
          :key="index"
        >
          {{ item.cityName }}
        </li>
      </ul>
      <div class="areaconfirm" v-else>
        <img src="../../../static/images/order/sc.png" class="custom-image" />
        <div>暂无限制兑换区域</div>
      </div>
      <div class="areaconfirm">
        <van-button
          round
          block
          color="var(--theme-color-main)"
          type="primary"
          @click="popupArea = false"
          >确认</van-button
        >
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getProductDetails,
  sysUserProvince,
  queryByProductIdAndSaleAreaIdApi,
  productStok,
  collectDelete,
  collectSave,
  haierOrderShoppingCart,
  getByRiskRule,
  AndProperty,
  getUserInfo,
  queryProductDescribe,
  sysUserProvinceListAll,
  sysUserCityListAll,
  sysUserAreaListAll,
  listSameCityArea,
  queryNoticeByTime,
  searchUserAddrList,
} from "../../api/api";
// import productItem from "@/components/product/productItem.vue";
import config from "@/config/config";
import { trackEventActive } from "@/matomo";
import utils from "@/utils/utils";

export default {
  components: {
    // productItem
  },
  data() {
    return {
      attValueId:undefined, // 规格id
      kucun: "",
      conversion: "",
      canSale: "",
      productcode: "",
      Product: false,
      available: false,
      codeid: "",
      productDescribleContent: "",
      chineseName: "",
      banners: "",
      integralNum: "",
      status: "",
      iac: [],
      disabled: false,
      num: "",
      type: 0, //兑换还是加入购物车
      memberCollectFlag: "", //收藏ID
      isCollected: false,
      city: "",
      hasProduct: "", //区域是否有货
      options: {
        province_list: {},
        city_list: {},
        county_list: {},
      },
      sameCityArea: {}, // 【省直辖县】市县相同对象
      sameCityAreaKeys: [], // 【省直辖县】市县相同对象
      specialAreas: [], // 特殊的区域
      previewList: [],
      imgList: [],
      codeList: [],
      productPropertyValueslist: [],
      productDetails: { afterSaleContent: "" },
      specsIndex: 0,
      popupMent: false,
      popupAddress: false, //地址弹出
      guarantee: false, //服务弹出
      productStatus: ["商品介绍", "商品参数", "包装售后"], //商品详情类型
      productStatusIndex: 0, //商品详情类型默认
      addressIndex: 0, //地址默认
      banner: [],
      productList: [],
      bannerIndex: 0,
      menuShow: false,
      popupShow: false,
      value: 1,
      collected: false,
      code: "", //兑换显示
      notice: "",
      popupArea: false, //配送限制
      address: null,
      active: 0, //默认tab
      applyCode: null,
      cardShow: null, //是否展示
      serviceBtn: true, //客服按钮,
      kucunvalue:true
    };
  },
  mounted: function (options) {
    let url = window.location.href;
    if (url.indexOf("level") > -1) {
      let level = url.match(/level=(\S*)/);
      this.level = level[1];
    }
    const hbscToken = this.$cookies.get("hbscToken") || sessionStorage.getItem("hbscToken") || "";
    var _this = this;
    // setTimeout(() => {
      _this.searchUserAddrList();
    // }, 1500);
    this.getProduct();
    // this.sysUserProvince();
    this.sysUserProvinceListAll();
    this.sysUserCityListAll();
    this.sysUserAreaListAll();
    this.queryProductDescribe();
    this.getNotice();
    this.applyCode = this.$route.query.applyCode;

    // const userAgent = navigator.userAgent.toLocaleLowerCase();
    // if (userAgent.indexOf("micromessenger") > -1) {
    //   wx.miniProgram.getEnv((res) => {
    //     if (res.miniprogram) {
    //       _this.serviceBtn = true;
    //     } else {
    //       //在微信中
    //       console.log("在微信中");
    //     }
    //   });
    // }
    // if (navigator.userAgent.indexOf('AliApp') > -1) {
    //   _this.serviceBtn = true;
    // }
  },
  methods: {
    // 获取公告
    async getNotice() {
      let res = await queryNoticeByTime();
      if (res.code === "0000") {
        if (res.data != null) {
          this.notice = res.data.context;
        }
      }
    },
    onConfirm(value) {
      if (value[2] == undefined && value[1] == undefined) {
        this.$toast("请选择");
        return;
      }
      console.log(value);
      this.region = value;
      this.city = value[0].name + "-" + value[1].name + "-" + value[2].name;
      // this.popupAddress = false;
    },
    /**
     *获取商品描述信息
     *tzc
     *2021-3-23 10:42:18
     */
    async queryProductDescribe() {
      var id = this.$route.query.id;
      let params = {
        productId: id,
        // type: 1,
        // promotionId: 1,
        // productType:1
      };
      let res = await queryProductDescribe(params);
      if (res.code === "0000") {
        this.productDescribleContent = res.data[0].content;
      } else {
        this.$toast(res.msg);
      }
    },

    //区域有无货
    async handleChange() {
      let params = {
        productId: 1,
        saleAreaCityId: 1,
      };
      let res = await queryByProductIdAndSaleAreaIdApi(params);
      this.hasProduct = res.data;
    },
    async haierOrderCheckArea(list) {
      if ((list[0].code == "" && list[0].name == "") || (list[0].code == null && list[0].name == null)) {
        this.$toast("请选择完整地区~");
        return;
      }

      if ((list[1].code == "" && list[1].name == "") || (list[1].code == null && list[1].name == null)) {
        this.$toast("请选择完整地区~");
        return;
      }
      if ((list[2].code == "" && list[2].name == "") || (list[2].code == null && list[2].name == null)) {
        this.$toast("请选择完整地区~");
        return;
      }
      // 选中市
      let selectedCity = list[1];
      // 选中县
      let selectedCounty = list[2];
      // 如果选中的县是省直辖县，就格式化一下选中的市
      if (Object.keys(this.sameCityArea).length > 0 && Object.keys(this.sameCityArea).indexOf(selectedCounty.code) > -1) {
        list[1] = selectedCounty;
      }
      // 如果选中的市是特殊的区域里面的话，就格式化一下选中的县
      if (this.specialAreas.length > 0 && this.specialAreas.indexOf(selectedCity.code) > -1) {
        list[2] = list[1];
      }
      let arr = list[0].name + " " + list[1].name + " " + list[2].name;
      //检验地区
      let params = {
        area: arr,
        thirdProductCode: this.productcode,
      };

      this.onConfirm(list);
      this.popupAddress = false;

      //暂时隐藏 后续可能用

      //   let res = await productStok(params);
      //   if (res.code == "0000") {
      //     this.Product = true;
      //     this.hasProduct = res.data;
      //     this.popupAddress = false;
      //   } else {
      //     this.Product = true;
      //     this.hasProduct = 0;
      //     this.popupAddress = false;
      //   }
      //暂时隐藏 后续可能用
    },

    //获取省市区列表
    async sysUserProvince() {
      let params = {};
      const res = await sysUserProvince(params);
      if (res.code === "0000") {
        let temp = res.data;
        //省市格式
        for (let i = 0; i < temp.length; i++) {
          this.options.province_list[temp[i].value] = temp[i].label;
        }

        //地级市格式
        for (let i = 0; i < temp.length; i++) {
          for (let j = 0; j < temp[i].children.length; j++) {
            this.options.city_list[temp[i].children[j].value] =
              temp[i].children[j].label;
          }
        }

        //区格式
        for (let i = 0; i < temp.length; i++) {
          for (let j = 0; j < temp[i].children.length; j++) {
            for (let k = 0; k < temp[i].children[j].children.length; k++) {
              this.options.county_list[temp[i].children[j].children[k].value] =
                temp[i].children[j].children[k].label;
            }
          }
        }
      } else {
        this.$toast(res.msg);
      }
    },
    // 省列表
    async sysUserProvinceListAll() {
      let params = {};
      const res = await sysUserProvinceListAll(params);
      if (res.code === "0000") {
        let temp = res.data;
        //省格式
        for (let i = 0; i < temp.length; i++) {
          this.options.province_list[temp[i].regionCode] = temp[i].regionName;
        }
      }
    },
    // 市列表
    async sysUserCityListAll() {
      let params = {};
      let this_ = this;
      const resSame = await listSameCityArea(params);
      if (resSame.code === "0000") {
        let sameKes = this_.sameCityAreaKeys;
        let sameData = resSame.data;
        // 市格式
        for (let i = 0; i < sameData.length; i++) {
          let sameCode = sameData[i].regionCode;
          let sameName = sameData[i].regionName;
          let codeSub = sameCode.slice(0, 3);
          let keyValue = {};
          keyValue[sameCode] = sameName;
          if (Object.keys(sameKes).indexOf(codeSub) < 0) {
            sameKes[codeSub] = [];
            sameKes[codeSub].push(keyValue);
          } else {
            sameKes[codeSub].push(keyValue);
          }
          this_.sameCityArea[sameCode] = sameName;
        }
        // 特殊县区
        if (this_.sameCityAreaKeys.length > 0) {
          Object.keys(this_.sameCityAreaKeys).forEach(function (key) {
            if (
              this_.sameCityAreaKeys[key].length === 1 &&
              Object.keys(this_.sameCityAreaKeys[key][0]).length > 0
            ) {
              this_.specialAreas.push(
                Object.keys(this_.sameCityAreaKeys[key][0])[0]
              );
            }
          });
        }
      }
      const res = await sysUserCityListAll(params);
      if (res.code === "0000") {
        let temp = res.data;
        //市格式
        for (let i = 0; i < temp.length; i++) {
          let regionCode = temp[i].regionCode;
          let regionCodeSub = regionCode.slice(0, 3);
          if (Object.keys(this_.sameCityAreaKeys).indexOf(regionCodeSub) < 0) {
            this_.options.city_list[regionCode] = temp[i].regionName;
          } else {
            // 省直辖县处理
            if (this_.sameCityAreaKeys[regionCodeSub].length > 1) {
              this_.options.city_list[regionCodeSub.concat("0", "0", "0")] =
                "省直辖县";
            } else {
              this_.options.city_list[regionCode] = temp[i].regionName;
            }
          }
        }
      }
    },
    // 区列表
    async sysUserAreaListAll() {
      let params = {};
      let this_ = this;
      const res = await sysUserAreaListAll(params);
      if (res.code === "0000") {
        let temp = res.data;
        // 区格式
        for (let i = 0; i < temp.length; i++) {
          let areaCode = temp[i].regionCode;
          // 特殊区处理
          if (
            this_.specialAreas.length > 0 &&
            this_.specialAreas.indexOf(areaCode) > -1
          ) {
            // console.log('改造前',areaCode,temp[i].regionName)
            // 【注意】：这里的区code不是数据库里的，最后一个位置换成了1
            this_.options.county_list[areaCode.slice(0, 5).concat("1")] =
              temp[i].regionName;
            // console.log('改造后',areaCode.slice(0,5).concat("1"),temp[i].regionName);
          } else {
            this_.options.county_list[areaCode] = temp[i].regionName;
          }
        }
      }
    },

    // 获取数据
    async getProduct() {
      let id = this.$route.query.id;
      let params = {
        showTerminal: 1,
        showDesk: 2,
        level: this.level,
        id: id,
      };
      let res = await getProductDetails(params);
      if (res.code === "0000") {
        this.productDetails = res.data;
        this.banners = res.data.pictureUrl[0].pictureUrl.split(",")[0];
        this.integralNum = res.data.defaultSkuProductInfo.integralNum;
        this.chineseName = res.data.defaultSkuProductInfo.chineseName;
        // this.skru = res.data.defaultSkuProductInfo;
        this.banner = res.data.pictureUrl;
        this.num = res.data.quotaNum;
        this.imgList = res.data.detailUrl.split(",");
        this.codeList = res.data.productPropertyList;
        this.attValueId = undefined; // 规格id
        if(this.codeList.length > 0 && this.codeList[0].productPropertyValues.length > 0){
          this.attValueId = this.codeList[0].productPropertyValues[0].attValueId;
        }
        if (this.$route.query.sources == "11") {
          this.cardShow == 100;
        } else {
          this.cardShow = res.data.bitConceal; //0-不隐藏 1-隐藏，不可兑换 2-隐藏，可兑换
        }
        if (res.data.availableType == 1) {
          this.available = false;
        } else {
          this.available = true;
        }
        if (res.data.canSale == 0) {
          this.$toast("该宝贝已经下架~");
        }
        this.memberCollectFlag = res.data.memberCollectFlag;

        if (this.memberCollectFlag == 1) {
          this.isCollected = true;
          // this.$toast("收藏成功");
        } else {
          this.isCollected = false;
          // this.$toast("取消收藏成功");
        }
        this.canSale = res.data.canSale;
        this.productcode = res.data.thirdProductCode;
      } else {
        this.imgList = require("../../../static/images/product/not-product.png");
        this.$toast(res.msg);
      }
    },
    //选择规格
    choseSpecs(index2, index, $event,it) {
      console.log(it,"-----选择规格-----")
      this.iac[index2] = index;
      this.iac = this.iac.concat([]);
     this.kucunvalue = it.available <1?false:true
      if (this.codeList.length == this.iac.length) {
        this.AndProperty();
      }
      //切换商品规格
      this.attValueId = it.attValueId;
    },
    //规格详情
    //这里的接口
    async AndProperty() {
      let that = this;
      let relationRequests = [];
      console.log(that.codeList,"---that.codeList")
      for (let i = 0; i < that.iac.length; i++) {
        let ll = that.codeList[i].productPropertyValues[this.iac[i]];
        let lldetail = that.codeList[i];
        ll.attNameId = lldetail.attNameId;
        // console.log(ll);
        ll.code = lldetail.code;
        ll.name = lldetail.name;
        ll.nameDeleteFlag = lldetail.nameDeleteFlag;
        ll.productId = lldetail.productId;
        ll.productParentId = lldetail.productParentId;
        // ll.productPropertyValues = lldetail.productPropertyValues;
        // ll.propertyNameRelationId = lldetail.propertyNameRelationId;
        relationRequests.push(ll);
      } //

      let params = {
        showTerminal: 1,
        showDesk: 2,
        level: this.level,
        productId: this.$route.query.id,
        relationRequests: relationRequests,
      };

      let res = await AndProperty(params);
      if (res.code == "0000") {
        // this.banners = res.data.pictureUrl[0].pictureUrl;
        that.integralNum = res.data.integralNum;
        that.chineseName = res.data.chineseName;
        that.kucun = res.data.available;
        that.codeid = res.data.id;
        that.parentId = res.data.parentId;
        that.conversion = res.data.conversion;
        that.banners = res.data.mainPictureUrl;
        if (res.data.availableType == 1) {
          that.available = false;
        } else {
          that.available = true;
        }
      }
      that.code = "";
      console.log(relationRequests,"---relationRequests")
      relationRequests.forEach((wl) => {
        that.code += wl.name + ":" + wl.valueName + ",";
      });
      that.code = that.code.substring(0, that.code.length - 1);
    },
    detail() {},
    //商品图
    bannerChange: function (e) {
      this.bannerIndex = e;
    },
    previewimg: function (e) {},
    closeMenu: function () {
      this.menuShow = false;
    },
    goshoping: function () {
      // if (this.$route.query.sources == "11") {
      //   gio("track", "MPZJ30220", {
      //     product_id: this.$route.query.id,
      //     product_name: this.productDetails.chineseName,
      //   });
      // }
      if (this.available == true) {
        // if (this.Product == false) {
        //   this.$toast("请选择配送地址~");
        //   return;
        // }
      }
      this.type = 2;
      this.getUserInfo();
      // this.getByRiskRule();

      //默认设置第一个规格
      this.iac[0] = 0;
      this.iac = this.iac.concat([]);
      console.log(this.iac,"----this.iac")
      if (this.codeList.length == this.iac.length) {
        this.AndProperty();
      }

      if (this.status == 1) {
        this.popupShow = false;
        this.$toast("加入购物车异常，请联系管理员");
        return;
      }

      this.popupShow = true;
    },
    exchange: function () {
      if (this.$route.query.sources == "11") {
        //  this.$matomo.trackEvent('MPZJ30221','MPZJ30221','MPZJ30221','MPZJ30221',{'product_id':this.$route.query.id,'product_name':this.productDetails.chineseName});
        trackEventActive(this, "MPZJ30221", {
          product_id: this.$route.query.id,
          product_name: this.productDetails.chineseName,
        });

        gio("track", "MPZJ30221", {
          product_id: this.$route.query.id,
          product_name: this.productDetails.chineseName,
        });
      }
      this.type = 1;
      if (this.available == true) {
        // if (this.Product == false) {
        //   this.$toast("请选择配送地址~");
        //   return;
        // }
      }

      // if (this.cardShow!=0&&this.$route.query.cardNo!=null) {
      //   // this.popupShow = false;
      //   this.$toast("此商品仅允许卡兑换");
      //   return;
      // }
      let _this = this;
      if (this.productDetails.mProductSalesAreaResponseList.length != 0) {
        var ifxf = this.productDetails.mProductSalesAreaResponseList.some(
          (item, index) => {
            if (this.region) {
              return (
                item.cityId == _this.region[1].code ||
                item.cityId == _this.region[0].code
              );
            } else if (this.address !== null && this.address.length !== 0) {
              return (
                item.cityId == _this.address.city_id ||
                item.provinceId == _this.address.city_id
              );
            }
          }
        );
      }
      if (ifxf) {
        this.$toast("限发区域，请重新选择");
        return;
      }
      this.getUserInfo();
      // this.getByRiskRule();
      // //默认设置第一个规格
      this.iac[0] = 0;
      this.iac = this.iac.concat([]);
      if (this.codeList.length == this.iac.length) {
        this.AndProperty();
      }
      if (this.status == 1) {
        // this.popupShow = false;
        this.$toast("立即兑换异常，请联系管理员");
        return;
      }

      this.popupShow = true;
    },
    async getUserInfo() {
      let params = {
        accessTokenPri:
          this.$cookies.get("hbscToken") || sessionStorage.getItem("hbscToken"),
      };

      let userInfo = await getUserInfo(params);
      this.status = userInfo.data.status;
    },
    addplus() {
      // console.log(this.value);
      if (this.value == this.num) {
        this.$toast(
          "根据商城规定，一个用户一次只能购买" + this.num + "件同种商品~"
        );
        this.max = this.num;
      }
    },
    // 校验下单数量
    async getByRiskRule() {
      let params = {};
      let res = await getByRiskRule(params);
      if (res.code == "0000") {
        this.num = res.data.frequency;
      }
    },
    //去购物车
    gocard() {
      // if (this.$route.query.sources == "11") {
      //   gio("track", "MPZJ30219", {
      //     product_id: this.$route.query.id,
      //     product_name: this.productDetails.chineseName,
      //   });
      // }
      this.$router.push({
        path: "/ShoppingCart",
        // query: {
        //     productList: encodeURIComponent(
        //         JSON.stringify([{
        //             id: this.$route.query.id,
        //             name: this.productDetails.chineseName,
        //             code: this.codeList[this.specsIndex],
        //             point: this.productDetails.integralNum,
        //             number: this.value,
        //             supplierCode: this.productDetails.supplierCode,
        //             supplierName: this.productDetails.supplierName,
        //             supplierV: this.productDetails.supplierVCode,
        //             goodsImgUrl: this.banner[0],
        //         }, ])
        //     ),
        // }
      });
    },
    // 去客服
    goService() {
      // let params = {
      //   userId: userid,
      //   userName: aname,
      //   p: phone,
      //   fromPageUrl: url,
      //   sign: sign,
      //   pid: "zjappwx",
      //   accountId: "jfzx",
      //   sceneId: "cj223",
      //   entranceId: "jt",
      //   fromPageTitle: "积分商城商品详情页",
      // };
      let hbscToken =
        this.$cookies.get("hbscToken") || sessionStorage.getItem("hbscToken");
      let memberId =
        this.$cookies.get("memberId") || sessionStorage.getItem("memberId");
      if (hbscToken == null || memberId == null) {
        this.$toast("请登录智家app或者小程序");
      } else {
        let str = utils.toService("zjapp", "jfzx", "cd0204", "积分商城商品详情页");
        location.href = config.serviceUrl + str;
      }
    },
    //添加购物车
    async showPopup() {
      // console.log(this.productDetails.available);
      // console.log(this.value);
      // console.log(this.hasProduct);
      if (this.available == true) {
        // if (this.Product == false) {
        //   this.$toast("请选择配送地址~");
        //   return;
        // }
        if (this.hasProduct == "0") {
          this.$toast("库存不足~");
          return;
        }
        if (this.hasProduct != "" && this.hasProduct <= this.value) {
          this.$toast("库存不足~");
          return;
        }
      } else if (this.available == false) {
        if (this.kucun == "0") {
          this.$toast("库存不足~");
          return;
        }
        if (this.productDetails.available === 0) {
          this.$toast("库存不足~");

          if (this.productDetails.available <= this.value) {
            this.$toast("库存不足~");
            return;
          }
          return;
        }
      }
      if (this.conversion == "1") {
        this.$toast("此商品用于卡兑换");
        return;
      }
      if (this.codeList.length != this.iac.length) {
        this.$toast("请选择商品规格~");
        return;
      }
      if (this.canSale == "0") {
        this.$toast("商品已经下架~");
        return;
      }
      if (this.codeList.length == 0) {
        this.code = "默认规格";
        // return;
      }
      this.goodid = this.codeid;
      if (this.codeid == "") {
        this.goodid = this.$route.query.id;
      }

      let params = {
        userId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        productId: this.parentId,
        skuId: this.goodid,
        amount: this.value,
        code: this.code,
        banners: this.banners,
        thirdProductCode: this.productcode,
      };

      const res = await haierOrderShoppingCart(params);
      if (res.code == "0000") {
        this.popupShow = false;

        this.$toast("加入成功，在购物车等亲~");
      }
    },
    // showPopup: function () {
    //     console.log("1212")
    // },
    change: function (e) {
      this.value = e.value;
    },
    collecting: function () {
      this.collected = !this.collected;
    },
    //全部评论
    allComments() {
      // this.productInfo.describe;
      this.$router.push({
        path: "/orders/allComments",
        query: {
          id: this.$route.query.id,
        },
      });
    },
    common: function () {},

    //去下单
    submit() {
      if (this.conversion == "1") {
        this.$toast("此商品用于卡兑换");
        return;
      }
      if (this.codeList.length != this.iac.length) {
        this.$toast("请选择商品规格~");
        return;
      }
      if (this.available == true) {
        // if (this.Product == false) {
        //   this.$toast("请选择配送地址~");
        //   return;
        // }
        if (this.hasProduct == "0") {
          this.$toast("库存不足~");
          return;
        }
        if (this.hasProduct != "" && this.hasProduct <= this.value) {
          this.$toast("库存不足~");
          return;
        }
      } else if (this.available == false) {
        if (this.kucun == "0") {
          this.$toast("库存不足~");
          return;
        }
        if (this.productDetails.available === 0) {
          this.$toast("库存不足~");

          if (this.productDetails.available <= this.value) {
            this.$toast("库存不足~");
            return;
          }
          return;
        }
      }
      if (this.canSale == "0") {
        this.$toast("商品已经下架~");
        return;
      }
      if (this.codeList.length == 0) {
        this.code = "默认规格";
        // return;
      }
      // console.log(this.codeList[this.specsIndex]);
      // this.popupShow = false;
      this.goodid = this.codeid;
      if (this.codeid == "") {
        this.goodid = this.$route.query.id;
      }

      if (this.$route.query.applyCode != null) {
        this.$router.push({
          path: "/submitOrder",
          query: {
            productList: encodeURIComponent(
              JSON.stringify([
                {
                  thirdProductCode: this.productcode,
                  id: this.attValueId ? this.attValueId : this.goodid,
                  name: this.chineseName,
                  code: this.code,
                  point: this.integralNum,
                  number: this.value,
                  supplierCode: this.productDetails.supplierCode,
                  supplierName: this.productDetails.supplierName,
                  supplierV: this.productDetails.supplierVCode,
                  goodsImgUrl: this.banners,
                  isPlus: this.productDetails.isPlus,
                  applyCode: this.$route.query.applyCode,
                  cardNo: this.$route.query.cardNo,
                  note: this.productDetails.note,
                  isOrderTip: this.productDetails.isOrderTip,
                  isGivePlus: this.productDetails.isGivePlus,
                },
              ])
            ),
            sources: this.$route.query.sources || 0,
          },
        });
      } else {
        this.$router.push({
          path: "/submitOrder",
          query: {
            productList: encodeURIComponent(
              JSON.stringify([
                {
                  thirdProductCode: this.productcode,
                  id: this.attValueId ? this.attValueId : this.goodid,
                  name: this.chineseName,
                  code: this.code,
                  point: this.integralNum,
                  number: this.value,
                  supplierCode: this.productDetails.supplierCode,
                  supplierName: this.productDetails.supplierName,
                  supplierV: this.productDetails.supplierVCode,
                  goodsImgUrl: this.banners,
                  isPlus: this.productDetails.isPlus,
                  note: this.productDetails.note,
                  isOrderTip: this.productDetails.isOrderTip,
                  isGivePlus: this.productDetails.isGivePlus,
                },
              ])
            ),
            sources: this.$route.query.sources || 0,
          },
        });
      }
    },
    //收藏商品
    async collectSave() {
      // if (this.$route.query.sources == "11") {
      //   gio("track", "MPZJ30218", {
      //     product_id: this.$route.query.id,
      //     product_name: this.productDetails.chineseName,
      //   });
      // }
      let params = {
        memberId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        productId: this.$route.query.id,
      };

      const res = await collectSave(params);
      if (res.code == "0000") {
        // this.isCollected = true;

        this.memberCollectFlag = res.data.memberCollectFlag;
        if (this.memberCollectFlag == 1) {
          this.isCollected = true;
          this.$toast("收藏成功");
        } else {
          this.isCollected = false;
          this.$toast("取消收藏成功");
        }
      }
    },
    //取消商品收藏
    async collectDelete() {
      let params = {
        id: this.memberCollectFlag,
        productId: this.$route.query.id,
      };

      const res = await collectDelete(params);
      if (res.code == "0000") {
        this.$toast("取消收藏成功！");
        this.isCollected = false;
      }
    },
    coupon() {},
    onShare() {},
    // 获取用户默认地址
    async searchUserAddrList() {
      let params = {};
      let res = await searchUserAddrList(params);
      if (res.code == "0000") {
        if (res.data[0] == null) {
          this.address = [];
        } else {
          for (let index = 0; index < res.data.length; index++) {
            if (res.data[index].is_default == 1) {
              this.address = res.data[index].address;
            }
          }

          this.city = this.address.province + "-" + this.address.city + "-" + this.address.district;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-title {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  padding: 20px 0;
}
.text >>> img {
  display: block;
  max-width: 100%;
}

.text >>> p {
  display: block;
  max-width: 100%;
}

.tui-paddingleft {
  padding-left: 10px;
  padding-right: 10px;
}

.van-cell::after {
  border: none;
}

/deep/.van-field__label {
  // font-size: 26px;
  color: #111;
  font-weight: bold;
}

.van-cell {
  padding: 0;
  //   width: 70%;
}

.distribution-result {
  // color: #2283e2;
  font-weight: bold;
  font-size: 28px;
}

.flex {
  display: flex;
}

.product-container {
  padding-bottom: 110px;
  background-color: #f1f1f1;
}

.tui-tag {
  border: 1px solid $theme-color-main;
  border-radius: 6px;
  padding: 5px 7px;
  color: $theme-color-main;
}

.tui-header-boxs {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 995;

  .tui-header-icon {
    position: fixed;
    top: 50px;
    left: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    transform: translateZ(0);
    z-index: 9999;
    background: rgba(0, 0, 0, 0.27);
    border-radius: 7px;
    font-size: 26px;
    color: #ffffff;
    padding: 0 15px;
  }
}

.tui-banner-swiper {
  position: relative;
  width: 100%;
  height: 100%;
}

.tui-banner-tag {
  position: absolute;
  color: #fff;
  bottom: 20px;
  right: 20px;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  font-size: 26px;
}

.tui-slide-img {
  width: 100%;
  height: 750px;
  display: block;
}

/*内容 部分*/
.tui-padding {
  padding: 0 30px;
  box-sizing: border-box;
}

.tui-ml-auto {
  margin-left: auto;
}

.tui-size {
  font-size: 24px;
  line-height: 24px;
}

.tui-gray {
  color: #999;
}

.tui-radius-all {
  // border-radius: 10px;
  overflow: hidden;
  margin-bottom: 4px;
  background-color: #ffffff;
}

.tui-mtop {
  margin-top: 26px;
}

.tui-pro-detail {
  box-sizing: border-box;
  color: #333;
  margin: 4px 0;
}

.tui-product-title {
  background: #fff;
  padding: 20px;
}

.tui-pro-pricebox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 4px solid #f9f9f9;
  line-height: 44px;
  .p-point {
    color: #ff201f;
    font-size: 36px;
  }
  .p-price {
    color: #999;
    font-size: 24px;
    font-family: "Microsoft YaHei";
  }
}

.tui-pro-price {
  display: flex;
  align-items: center;
}

.tui-price {
  font-size: 48px;
}

.tui-original-price {
  font-size: 26px;
  line-height: 26px;
  padding: 10px 30px;
  box-sizing: border-box;
}

.tui-line-through {
  text-decoration: line-through;
  font-size: 24px;
}

.tui-collection {
  color: #333;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 44px;
}

.tui-scale-collection {
  transform: scale(0.7);
  transform-origin: center 90%;
  line-height: 24px;
  font-weight: normal;
  margin-top: 4px;
}

.tui-pro-titbox {
  // height: 84px;
  font-size: 35px;
  font-weight: 500;
  position: relative;
  box-sizing: border-box;
  margin-top: 30px;
  // margin-bottom: 40px;
  border-bottom: 4px solid #f9f9f9;
  padding-bottom: 16px;
}

.tui-pro-title {
  width: 95%;
  // overflow: hidden;
  // white-space: nowrap;
  //  text-overflow: ellipsis;
}

.tui-pro-text {
  // width: 95%;
  // overflow: hidden;
  // white-space: nowrap;
  padding-top: 10px;
  font-size: 26px;
  color: #999;
}

.tui-share-btn {
  display: block;
  background: transparent;
  margin: 0;
  padding: 0;
  border-radius: 0;
  border: 0;
}

.tui-share-btn::after {
  border: 0;
}

.tui-share-box {
  width: 95px;
  height: 40px;
  background: #d80c18;
  border-radius: 20px 0 0px 20px;
  font-size: 26px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-right: -20px;
}

.tui-share-position {
  position: absolute;
  right: 0;
  top: 30px;
}

.tui-share-text {
  padding-left: 8px;
}

.tui-sub-title {
  padding: 0px 20px;
  background: $theme-color-main;
  height: 88px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  font-size: 28px;
}

.tui-sale-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
}

.tui-list-cell {
  display: flex;
  align-items: center;
  // font-size: 26px;
  // line-height: 26px;
  // padding: 30px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.tui-right {
  position: absolute;
  right: 30px;
  top: 30px;
}

.tui-bold {
  font-weight: bold;
}

.tui-last {
  border-bottom: 1px solid #efefef;
  width: 95%;
  margin: 0 auto;
}

.tui-flex-center {
  display: flex;
  align-items: center;
}

.tui-cell-title {
  // width: 66px;
  padding-right: 30px;
  flex-shrink: 0;
}

.tui-promotion-box {
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 550px;
}

.tui-promotion-box p {
  margin-left: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tui-guarantee {
  display: flex;
  flex-wrap: wrap;
  font-size: 24px;
}

.tui-guarantee-item {
  display: flex;
  color: #666666;
  padding-right: 30px;
  padding-bottom: 25px;
}

.tui-pl {
  padding-left: 4px;
}

.tui-between {
  justify-content: space-between !important;
}

.tui-cmt-all {
  color: $theme-color-main;
  padding-right: 8px;
}

.tui-cmt-content {
  font-size: 26px;
}

.tui-cmt-user {
  display: flex;
  align-items: center;
}

.tui-acatar {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: block;
  margin-right: 16px;
}

.tui-cmt {
  padding: 14px 0;
}

.tui-attr {
  font-size: 24px;
  color: #999;
  padding: 6px 0;
}

.tui-cmt-btn {
  padding: 50px 0 30px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tui-nomore-box {
  padding-top: 10px;
}

.tui-product-img {
  display: flex;
  flex-direction: column;
  transform: translateZ(0);
}

.tui-product-img img {
  width: 100%;
  display: block;
}

/*底部操作栏*/
.tui-operation {
  width: 100%;
  background: #ffffff;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  bottom: 0;
  left: 0;
  padding: 12px 0;
  flex-direction: row-reverse;
  padding-bottom: 28px;
}
.dhbox{
  width: 60%;
  justify-content: end;
  /deep/.van-button{
    height: 70px;
  }
}
.tui-operation-left {
  display: flex;
  align-items: center;
  width:43%
}

.tui-operation-items {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  width: 100px;
}

.tui-operation-text {
  font-size: 20px;
  color: #666666;
}

.tui-opacity {
  opacity: 0.5;
}

.tui-right-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tui-flex-1 {
  flex: 1;
  padding: 16px;
}

// .tui-flex {
//     padding-right: 16px;
// }

/*底部操作栏*/

/*底部选择弹层*/
.tui-popup-box {
  position: relative;
  padding: 30px 0 100px 0;
}

.tui-popup-btn {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}

.tui-product-box {
  display: flex;
  font-size: 24px;
  padding-bottom: 30px;
}

.tui-popup-img {
  height: 200px;
  width: 200px;
  border-radius: 24px;
  display: block;
}

.tui-popup-price {
  padding-left: 20px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .tui-name {
    padding-right: 100px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    height: 80px;
    font-size: 28px;
    color: #333333;
  }

  .tui-amount {
    color: #ff201f;
    font-size: 48px;
  }

  .tui-amount:before {
    // content: "¥";
    font-size: 28px;
    margin-right: 10px;
  }
}

.tui-popup-scroll {
  height: 600px;
  font-size: 26px;
  overflow: scroll;
}

.tui-scrollview-box {
  padding: 0 30px 60px 30px;
  box-sizing: border-box;
}

.tui-attr-title {
  padding: 16px 0;
  color: #333;
  font-size: 28px;
  border-bottom: 4px solid #f9f9f9;
}

.tui-attr-box {
  font-size: 0;
  padding: 20px 0;
}

.tui-attr-item {
  max-width: 100%;
  min-width: 120px;
  height: 60px;
  display: -webkit-inline-flex;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f1f1f1;
  padding: 0 20px;
  box-sizing: border-box;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 26px;
  border-radius: 30px;
}

.tui-attr-active {
  background: $theme-color-main !important;
  color: #fff;
  font-weight: bold;
  position: relative;
}

.tui-number-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 20px 0 30px 0;
  box-sizing: border-box;
}

.tui-box {
  display: flex;
  align-items: center;
  // padding: 20px 0 30px 0;
  box-sizing: border-box;
}

.tui-paddingright {
  padding-right: 30px;
}

.chose-ck {
  overflow: hidden;
}

.chose-ck dt {
  padding: 0.15rem 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  float: left;
  margin: 0 0.2rem 0.2rem 0;
  font-size: 0.28rem;
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  transition: all 0.5s;
}

.chose-ck dt.check {
  border: 1px solid #2283e2;
  color: #2283e2;
}

.chose-ck p {
  color: rgba(0, 0, 0, 0.87);
  line-height: 0.8rem;
}

/*底部选择弹层*/

/*商品类型切换*/
.tui-product-status {
  display: flex;
  flex: 1;
  height: 96px;
  border-radius: 10px;
  overflow: hidden;
  align-items: center;
  background-color: #ffffff;
  font-size: 28px;
  color: #999999;

  div {
    width: 33.3%;
    height: 100%;
    text-align: center;
    line-height: 96px;
  }

  .tui-product-status-active {
    background-color: $theme-color-main;
    color: #ffffff;
    overflow: hidden;
  }
}

/*推荐*/
.recommend-title {
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    margin: 50px 20px;
  }

  .line {
    width: 40px;
    height: 5px;
    background: linear-gradient(270deg, #fda42f 0%, #f25541);
    border-radius: 3px;
  }
}

/*分期*/
.ment {
  display: flex;
  flex-wrap: wrap;

  li {
    height: 180px;
    line-height: 180px;
    border: 1px solid #dedede;
    text-align: center;
    width: 49.5%;
    font-size: 28px;
    border-radius: 5px;
    .ment-money:before {
      content: "¥";
      font-size: 26px;
      color: $theme-color-main;
    }
  }
}
.border-bottom {
  border-bottom: 4px solid;
}
.yx {
  justify-content: space-between;
}
.yxcount {
  padding-right: 20px;
  color: #999;
}
.areatip {
  margin-top: 40px;
  font-size: 24px;
  color: #666;
  background-color: #eee;
  padding: 10px;
}
.areabox {
  padding: 30px;
  font-size: 26px;
  display: flex;
  //   justify-content: space-between;
  flex-wrap: wrap;

  li {
    border: 1px solid #666;
    margin-bottom: 10px;
    padding: 6px 10px;
    color: #666;
    margin-right: 20px;
  }
}
.areaconfirm {
  margin-top: 60px;
  text-align: center;
 .van-button {
    width: 60%;
    margin: auto;
  }
  img {
    width: 100px;
  }
}

/deep/.van-tabs__line {
  background-color: #2283e2;
}
/deep/.van-field__label {
  width: 4em;
}
/deep/.van-field__body {
  font-size: 26px;
}
.xf {
  justify-content: space-between;
  padding-right: 20px;
}
ul.ts {
  width: 100%;
  color: #999;
  padding: 10px 0;
  li {
    list-style: inside;
    float: left;
    width: 33%;
    text-align: center;
    font-size: 24px;
    font-family: "Microsoft YaHei";
  }
}
/deep/ .van-button--normal{
  padding: 0 0.3rem;
}
.grey{
  color: rgba(0, 0, 0, 0.15);
  position: relative;
}
.grey:after{
  content:"缺货";
  font-size: 2px;
  position: absolute;
  top:-30px;
  right:-34px;
  color: #111;
  background-color:  rgba(0, 0, 0, 0.15);
}
</style>
